import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const makeApi = (getToken) => {
  const client = axios.create({ baseURL: API });
  client.interceptors.request.use(async (cfg) => {
    if (getToken) {
      try {
        const token = await getToken();
        if (token) cfg.headers.Authorization = `Bearer ${token}`;
      } catch (e) {
        console.error("Could not get session token", e);
      }
    }
    return cfg;
  });
  return client;
};

export const publicApi = axios.create({ baseURL: API });
